
jQuery(document).ready(function($) {

    $('table button[data-action="play"]').on('click', function(){
        let button = $(this);
        let filename = $(this).data('filename') + '';

        if (filename.length) {
            $('.tooltip').remove();
            $('.audio-player').remove();

            let player = document.createElement('audio');
            player.src =  `/media/${filename}`;
            player.volume = 1;

            button.addClass('playing');
            player.addEventListener('ended', function(){
                button.removeClass('playing');
                $('.audio-player').remove();
            });

            let playerElement = $(player);
            playerElement.addClass('audio-player').addClass('d-none');
            $('body').append(playerElement);

            player.play();
        }
    });

});
